import React, { useEffect, useState } from 'react';
import { Grid, Typography, Container, Skeleton, Stack } from '@mui/material';
import BlogPostCard from '../components/blog/BlogPostCard';
import { getRecentPosts } from '../services/api';
import { BlogPost } from '../types/BlogPost';
import { SnackbarProvider, enqueueSnackbar } from 'notistack';


const Home = ({ content }: any) => {

  const [isLoading, setIsLoading] = useState(false);
  const [posts, setPosts] = useState<BlogPost[]>([]);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        setIsLoading(true)
        const { data }: any = await getRecentPosts();
        const formattedPost = (data as any[]).map(({ _id, ...rest }) => ({
          id: _id,
          ...rest
        }));
        setPosts(formattedPost as any)
      } catch (error) {
        enqueueSnackbar((error as any).message, { variant: 'error' });
      } finally {
        setIsLoading(false);
      }
    }
    fetchPosts()
  },[]);

  return (
    <Container maxWidth="lg">
      <Typography variant="h3" component="h1" gutterBottom align="center" sx={{ my: 4 }}>
        {content?.headerTitle}
      </Typography>
      <Typography variant="h5" component="h2" gutterBottom align="center" color="text.secondary" sx={{ mb: 4 }}>
        {content?.headerSubtitle}
      </Typography>
      <Grid 
        container 
        spacing={4} 
        sx={{
          display: 'flex',
          alignItems: 'stretch',
          '& .MuiGrid-item': {
            display: 'flex',
          },
        }}
      >
        {isLoading ? (
          <Grid container spacing={4}>
            {[...Array(6)].map((_, index) => (
              // @ts-ignore - Ignoring the item prop type issue
              <Grid item key={index} xs={12} sm={6} md={4}>
                <Stack spacing={1}>
                  <Skeleton variant="rectangular" width="300px" height={200} />
                  <Skeleton variant="text" width="80%" height={24} />
                  <Skeleton variant="text" width="60%" height={20} />
                  <Skeleton variant="text" width="90%" height={16} />
                  <Skeleton variant="text" width="70%" height={16} />
                </Stack>
                </Grid>
              ))}
            </Grid>
            ) : posts.length === 0 ? (
              <Typography variant="h6" align="center" sx={{ my: 4 }}>
                No posts found matching your criteria.
              </Typography>
            ) : (
              posts.map((post) => (
                // @ts-ignore - Ignoring the item prop type issue
                <Grid item key={post.id} xs={12} sm={6} md={4}>
                  <BlogPostCard post={post} />
                </Grid>
              ))
            )}
      </Grid>
      <SnackbarProvider />
    </Container>
  );
};

export default Home; 